import { useTranslation } from 'react-i18next';
import type { ILawPartProps } from './ILawPartProps';
import { relationCell, usedSubjects } from './lawArticles';
import { lawValue } from './lawGroups';
import { normTone } from './lawTones';

/**
 * «Суспільні відносини: хто кому що повинен» (прототип v4 lawRelRows): матриця суб'єктів, що трапляються в статтях (у порядку варіантів
 * поля), — рядок «хто», колонка «щодо кого», у клітинці — статті «Ст. N · Норма» кольору норми; діагональ — на --surface2.
 */
export function LawRelations({ arts, labels, onOpen }: ILawPartProps) {
  const { t } = useTranslation();
  const used = usedSubjects(arts, labels.order('ldart', 'subject'));
  const grid = { gridTemplateColumns: `minmax(130px,160px) repeat(${Math.max(1, used.length)},minmax(130px,1fr))` };
  const subject = (s: string) => labels.option('ldart', 'subject', s);
  return (
    <section className="law-sec">
      <div className="law-sec__title">{t('recordPage.law.relations')}</div>
      <div className="law-mx__scroll">
        <div className="law-mx law-mx--rel" style={grid}>
          <div className="law-mx__corner">{t('recordPage.law.relCorner')}</div>
          {used.map((s) => <div key={s} className="law-mx__head">{subject(s)}</div>)}
          {used.map((who) => (
            <div key={who} className="law-mx__row">
              <div className="law-mx__label">{subject(who)}</div>
              {used.map((to) => (
                <div key={to} className={who === to ? 'law-mx__cell law-mx__cell--self' : 'law-mx__cell'}>
                  {relationCell(arts, who, to).map((a) => (
                    <button key={a.id} type="button" className={`law-chip law-chip--rel law-t-${normTone(a.values['norm'])}`} onClick={() => onOpen('ldart', a)}>
                      {labels.article(a.values['num'])} · {labels.option('ldart', 'norm', lawValue(a, 'norm'))}
                    </button>
                  ))}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
